import { Option } from "@opendaw/lib-std";
export class EngineVariant {
    static install(provider) {
        this.#provider = Option.wrap(provider);
    }
    // The variant to boot the NEXT EngineWorklet with, resolved at construction time so an engine restart
    // always honors the current selection. Null selects the built-in TS engine.
    static current() {
        return this.#provider.mapOr(provider => provider(), null);
    }
    static #provider = Option.None;
}
